// TODO - move to environment variables when moved to clean react app
const sentryLink = 'http://1fde94d7d2574b17b2b47dbc74669ab5@sentry.tools.infiniteloop.eu/'; // 43 for staging, 42 for production
const sentryEndpoint = process.env.NODE_ENV === 'production' ? sentryLink + 42 : sentryLink + 43;

export default sentryEndpoint;
